import React, { FC, useEffect } from 'react';

import ProgressRing from '@adsk/alloy-react-progress-ring';
import {
  TOTAL_REMOTE_LOADING_TIME,
  TRACKING_ACTIONS,
  trackLoadingTime,
} from '@adsk/exo-skeleton-api';

import FlexCentered from './FlexCentered';

const AppContentLoader: FC<{ scope: string; moduleName: string }> = ({
  scope,
  moduleName,
}) => {
  useEffect(() => {
    void trackLoadingTime({
      scope,
      moduleName,
      action: TRACKING_ACTIONS.START,
      trackingId: 'remote-entry-loading',
      parentTrackingId: TOTAL_REMOTE_LOADING_TIME,
    });

    return () => {
      void trackLoadingTime({
        scope,
        moduleName,
        action: TRACKING_ACTIONS.END,
        trackingId: 'remote-entry-loading',
        parentTrackingId: TOTAL_REMOTE_LOADING_TIME,
      });
    };
  }, [scope, moduleName]);

  return (
    <FlexCentered height="100%" width="100%">
      <ProgressRing
        data-testid="AppContentLoader"
        size={ProgressRing.SIZES.LARGE}
      />
    </FlexCentered>
  );
};

export default AppContentLoader;
